import React from "react";

interface Props {
  children: React.ReactNode;
}

export const MainLayoutPublib: React.FC<Props> = ({ children }) => {
  return (
    <div className="main-layout--wrapper min-h-screen min-w-screen lg:pb-0 bg-base-300 overflow-hidden login z-50">
      <div className="flex flex-col items-center justify-center w-full h-full transition-all">
        {/* Content Area */}
        <div
          className={`flex-1 flex flex-col items-center justify-center min-h-screen text-base-content  overflow-hidden`}
        >
          {children}
        </div>
        {/* //Content Area */}
      </div>
    </div>
  );
};
